import moment from 'moment'

const EventSignInView = ({ 
  events, selectedEventId, setSelectedEventId, loadingEvents,
  eventCode, setEventCode, onSubmit, errorMsg, setErrorMsg 
}) => {
  const handleSubmit = (e) => {
    e.preventDefault()
    if (eventCode && selectedEventId) {
      onSubmit()
    }
  }

  if (loadingEvents) {
    return <div style={{ display: 'grid', justifyContent: 'center', padding: '20px' }}>Loading...</div>
  }

  if (!events || events.length === 0) {
    return (
      <div style={{ display: 'grid', justifyContent: 'center', padding: '20px' }}>
        <h3>No Events Found</h3>
        <p>There are no events scheduled for the current year.</p>
      </div>
    )
  }

  return (
    <div style={{ display: 'grid', justifyContent: 'center', padding: '20px' }}>
      <form onSubmit={handleSubmit}>
        <div id="eventInstructionContainer" style={{ marginBottom: '10px' }}>Select Event</div>
        <div id="eventSelectContainer" style={{ marginBottom: '20px' }}>
          <select
            className="eventSelectInput"
            value={selectedEventId}
            onChange={(e) => setSelectedEventId(e.target.value)}
            style={{ width: '100%', padding: '10px', fontSize: '16px' }}
          >
            {events.map((event) => (
              <option key={event.eventId} value={event.eventId}>
                {moment(event.eventDate).format('MMM Do, YYYY')} - {event.courseName || 'Unknown Course'}
              </option>
            ))}
          </select>
        </div>

        <div id="eventInstructionContainer">Enter Event Code</div>
        <div id="eventCodeContainer">
          <input
            type="text"
            className="eventCodeInput"
            value={eventCode}
            onChange={(e) => {
              setEventCode(e.target.value.toUpperCase())
              setErrorMsg('')
            }}
            autoFocus
          />
        </div>
        <div id="errorContainer">{errorMsg}</div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
          <button type="submit" className="darkButton" style={{ width: '200px' }} disabled={!eventCode || !selectedEventId}>
            Sign In
          </button>
        </div>
      </form>
    </div>
  )
}

export default EventSignInView
